var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
var locals_ = (locals || {}),schema = locals_.schema,default_value = locals_.default_value,value = locals_.value;
var jade_indent = [];
buf.push("\n<div class=\"row\">\n  <div class=\"col-lg-12\">\n    <div style=\"display: none\" class=\"alert alert-danger\"></div>\n    <form class=\"form-horizontal\">");
// iterate schema.properties
;(function(){
  var $$obj = schema.properties;
  if ('number' == typeof $$obj.length) {

    for (var name = 0, $$l = $$obj.length; name < $$l; name++) {
      var property = $$obj[name];

default_value = property.default_value
if (!default_value) default_value = ""
buf.push("\n      <div" + (jade.cls(['form-group',"field-group-" + (name) + ""], [null,true])) + ">\n        <label class=\"control-label field-name col-lg-4\">" + (jade.escape((jade_interp = name.replace(/_/g, ' ')) == null ? '' : jade_interp)) + "</label>\n        <div class=\"col-lg-8\">");
if (property.type == 'integer' || property.type == 'float')
{
buf.push("\n          <input type=\"text\"" + (jade.attr("name", "" + (name) + "", true, false)) + (jade.attr("disabled", default_value=='[Function]', true, false)) + (jade.attr("placeholder", "" + (default_value == '[Function]' ? 'Auto' : default_value) + "", true, false)) + (jade.cls(['form-control',"" + (default_value == '[Function]' ? 'disabled' : '') + ""], [null,true])) + "/>");
}
else if (property.type == 'boolean')
{
value = default_value ? true : false
buf.push("\n          <label class=\"control-label radio-inline\">\n            <input type=\"radio\"" + (jade.attr("name", "" + (name) + "", true, false)) + " value=\"1\"" + (jade.attr("checked", value, true, false)) + "/>YES\n          </label>\n          <label class=\"control-label radio-inline\">\n            <input type=\"radio\"" + (jade.attr("name", "" + (name) + "", true, false)) + " value=\"0\"" + (jade.attr("checked", !value, true, false)) + "/>NO\n          </label>");
}
else if (property.type == 'timestamp')
{
buf.push("\n          <div" + (jade.cls(['input-group',"" + (default_value == '[Function]' ? '' : 'date') + ""], [null,true])) + ">\n            <input type=\"text\"" + (jade.attr("name", "" + (name) + "", true, false)) + (jade.attr("disabled", default_value=='[Function]', true, false)) + (jade.attr("placeholder", "" + (default_value == '[Function]' ? 'Auto' : default_value) + "", true, false)) + (jade.cls(['form-control',"date " + (default_value == '[Function]' ? 'disabled' : '') + ""], [null,true])) + "/><span class=\"input-group-addon\"><i class=\"fa fa-th\"></i></span>\n          </div>");
}
else
{
buf.push("\n          <input type=\"text\"" + (jade.attr("name", "" + (name) + "", true, false)) + (jade.attr("disabled", default_value=='[Function]', true, false)) + (jade.attr("placeholder", "" + (default_value == '[Function]' ? 'Auto' : default_value) + "", true, false)) + (jade.cls(['form-control',"" + (default_value == '[Function]' ? 'disabled' : '') + ""], [null,true])) + "/>");
}
buf.push("\n          <div class=\"help-block\"></div>\n        </div>\n      </div>");
    }

  } else {
    var $$l = 0;
    for (var name in $$obj) {
      $$l++;      var property = $$obj[name];

default_value = property.default_value
if (!default_value) default_value = ""
buf.push("\n      <div" + (jade.cls(['form-group',"field-group-" + (name) + ""], [null,true])) + ">\n        <label class=\"control-label field-name col-lg-4\">" + (jade.escape((jade_interp = name.replace(/_/g, ' ')) == null ? '' : jade_interp)) + "</label>\n        <div class=\"col-lg-8\">");
if (property.type == 'integer' || property.type == 'float')
{
buf.push("\n          <input type=\"text\"" + (jade.attr("name", "" + (name) + "", true, false)) + (jade.attr("disabled", default_value=='[Function]', true, false)) + (jade.attr("placeholder", "" + (default_value == '[Function]' ? 'Auto' : default_value) + "", true, false)) + (jade.cls(['form-control',"" + (default_value == '[Function]' ? 'disabled' : '') + ""], [null,true])) + "/>");
}
else if (property.type == 'boolean')
{
value = default_value ? true : false
buf.push("\n          <label class=\"control-label radio-inline\">\n            <input type=\"radio\"" + (jade.attr("name", "" + (name) + "", true, false)) + " value=\"1\"" + (jade.attr("checked", value, true, false)) + "/>YES\n          </label>\n          <label class=\"control-label radio-inline\">\n            <input type=\"radio\"" + (jade.attr("name", "" + (name) + "", true, false)) + " value=\"0\"" + (jade.attr("checked", !value, true, false)) + "/>NO\n          </label>");
}
else if (property.type == 'timestamp')
{
buf.push("\n          <div" + (jade.cls(['input-group',"" + (default_value == '[Function]' ? '' : 'date') + ""], [null,true])) + ">\n            <input type=\"text\"" + (jade.attr("name", "" + (name) + "", true, false)) + (jade.attr("disabled", default_value=='[Function]', true, false)) + (jade.attr("placeholder", "" + (default_value == '[Function]' ? 'Auto' : default_value) + "", true, false)) + (jade.cls(['form-control',"date " + (default_value == '[Function]' ? 'disabled' : '') + ""], [null,true])) + "/><span class=\"input-group-addon\"><i class=\"fa fa-th\"></i></span>\n          </div>");
}
else
{
buf.push("\n          <input type=\"text\"" + (jade.attr("name", "" + (name) + "", true, false)) + (jade.attr("disabled", default_value=='[Function]', true, false)) + (jade.attr("placeholder", "" + (default_value == '[Function]' ? 'Auto' : default_value) + "", true, false)) + (jade.cls(['form-control',"" + (default_value == '[Function]' ? 'disabled' : '') + ""], [null,true])) + "/>");
}
buf.push("\n          <div class=\"help-block\"></div>\n        </div>\n      </div>");
    }

  }
}).call(this);

buf.push("\n    </form>\n  </div>\n</div>");;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}